import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import './styles.scss';
import ProgressBar from '../ProgressBar';
import PickupCount from '../PickupCount';
import FormInput from '../FormInput';
import { TextField } from '@material-ui/core';
import Search from './../../icons/icons-search.svg';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Table from '@material-ui/core/Table';
import MenuItem from '@material-ui/core/MenuItem';
import Menu from '@material-ui/core/Menu';
import RemoveUser from './Modals/RemoveUser';
import ChangeRole from './Modals/ChangeRole';
import AddUser from './Modals/AddUser';
import { resendInvite } from '../../screens/Admin/actions';

import LoaderGif from '../../icons/LoaderGif.gif';

function ImageLoader({ value }) {
    const defaultPartnerImage =
        'https://litterati-avatars-prod.s3-us-west-2.amazonaws.com/users/user-default/profile-picture-aqua.png';

    return <img src={value || defaultPartnerImage} className="crosslogo" />;
}

ImageLoader.displayName = 'MyComponent';
ImageLoader.propTypes = {
    value: PropTypes.string,
};
ImageLoader.defaultProps = {
    value: null,
};

function AdminContentUsers({ users, count, loading, error }) {
    const dispatch = useDispatch();
    const [filter, setFilter] = useState('');
    const [anchorEl, setAnchorEl] = useState({});
    const [addUserModal, setAddUserModal] = useState(false);
    const [removeUserModal, setRemoveUserModal] = useState(false);
    const [changeRolesModal, setChangeRolesModal] = useState(false);
    const [user, setUser] = useState({});

    const handleClick = (e, text) => {
        setAnchorEl({ text, target: e.currentTarget });
    };

    const handleClose = () => {
        setAnchorEl({});
    };

    const onResendInvite = (item) => {
        dispatch(resendInvite(item.email));
        handleClose();
    };

    const onDeleteUser = (item) => {
        setRemoveUserModal(true);
        setUser(item);
    };
    const onDeleteCancel = () => {
        handleClose();
        setRemoveUserModal(false);
        setUser({});
    };

    const onChangeRoleUser = (item) => {
        setChangeRolesModal(true);
        setUser(item);
    };
    const onRolesChangeCancel = () => {
        setChangeRolesModal(false);
        setUser({});
    };

    const {
        totalAdminsCount,
        currentAdminsCount,
        totalCitizenScientistCount,
        currentCitizenScientistCount,
    } = count || {};

    const columns = [
        {
            id: 'profilePicture',
            label: '',
            width: '5%',
            format: (value) => ImageLoader({ value }),
        },
        {
            id: 'fullName',
            width: '22%',
            label: 'Name',
            format: (value) => value || '---',
        },
        {
            id: 'username',
            label: 'Username',
            width: '22%',
            format: (value) => value || '---',
        },
        {
            id: 'email',
            width: '22%',
            label: 'Email',
            format: (value) => value || '---',
        },
        {
            id: 'roleIds',
            width: '22%',
            label: 'Role(s)',
            format: ({ id, roleTypeId }) => {
                roleTypeId = roleTypeId.sort();
                let roles = roleTypeId
                    .map((item) => (item === 3 ? 'Admin' : 'Researcher'))
                    .join(', ');
                let inviteStatus = !id ? 'User Invited' : null;

                return inviteStatus ? `${inviteStatus} - ${roles}` : roles;
            },
        },
        {
            id: 'actions',
            width: '5%',
            label: 'Actions',
        },
    ];

    let filteredUsers = users.filter(
        (item) =>
            Object.values(item)
                .join('')
                .indexOf(filter) > -1,
    );

    function getContent() {
        return (
            <div className="admin-flow-box content-users">
                <RemoveUser
                    open={removeUserModal}
                    user={user}
                    onCancel={onDeleteCancel}
                    onConfirm={() => {}}
                    canRemoveOwner={
                        users.filter((item) => item.isCreator).length > 1
                    }
                />
                <AddUser
                    open={addUserModal}
                    onCancel={() => setAddUserModal(false)}
                    onConfirm={() => {}}
                    emails={users.map((item) => item.email.toLowerCase())}
                    totalAdminsCount={totalAdminsCount}
                    currentAdminsCount={currentAdminsCount}
                    totalCitizenScientistCount={totalCitizenScientistCount}
                    currentCitizenScientistCount={currentCitizenScientistCount}
                />
                <ChangeRole
                    open={changeRolesModal}
                    user={user}
                    onCancel={onRolesChangeCancel}
                    onConfirm={() => {}}
                    totalAdminsCount={totalAdminsCount}
                    currentAdminsCount={currentAdminsCount}
                    totalCitizenScientistCount={totalCitizenScientistCount}
                    currentCitizenScientistCount={currentCitizenScientistCount}
                    canRemoveOwner={
                        users.filter((item) => item.isCreator).length > 1
                    }
                />
                {loading ? (
                    <div className="row justify-content-center">
                        <img src={LoaderGif} />
                    </div>
                ) : (
                    <div className="card-header">
                        {error ? (
                            error
                        ) : (
                            <>
                                <div className="row">
                                    <div className="col">
                                        <FormInput
                                            title={''}
                                            stylesIcon={{
                                                justifyContent: 'center',
                                            }}
                                            bootstrapIcon={Search}
                                        >
                                            <TextField
                                                value={filter}
                                                type={'text'}
                                                placeholder={
                                                    'Search by Name, Email, Username'
                                                }
                                                onChange={(event) => {
                                                    setFilter(
                                                        event.target.value,
                                                    );
                                                }}
                                            />
                                        </FormInput>
                                    </div>
                                    <div className="col"></div>
                                    <div className="col">
                                        <button
                                            className="btn btn-custom btn-partner"
                                            onClick={() =>
                                                setAddUserModal(true)
                                            }
                                            disabled={
                                                currentAdminsCount ===
                                                    totalAdminsCount &&
                                                currentCitizenScientistCount ===
                                                    totalCitizenScientistCount
                                            }
                                        >
                                            + Invite User
                                        </button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col col-progress">
                                        <PickupCount
                                            countText={'Admin Seats'}
                                            count={currentAdminsCount || 0}
                                            total={totalAdminsCount || 0}
                                            loading={false}
                                        />
                                        <ProgressBar
                                            progress={
                                                ((currentAdminsCount || 0) /
                                                    (totalAdminsCount || 10)) *
                                                100
                                            }
                                        />
                                    </div>
                                    <div className="col col-progress">
                                        <PickupCount
                                            countText={'Researcher Seats'}
                                            count={
                                                currentCitizenScientistCount ||
                                                0
                                            }
                                            total={
                                                totalCitizenScientistCount || 0
                                            }
                                            loading={false}
                                        />
                                        <ProgressBar
                                            progress={
                                                ((currentCitizenScientistCount ||
                                                    0) /
                                                    (totalCitizenScientistCount ||
                                                        10)) *
                                                100
                                            }
                                        />
                                    </div>
                                </div>
                                <br />
                                <div className="row">
                                    <div className="col">
                                        <TableContainer className={''}>
                                            <Table
                                                stickyHeader
                                                aria-label="sticky table"
                                            >
                                                <TableHead>
                                                    <TableRow>
                                                        {columns.map(
                                                            (column) => (
                                                                <TableCell
                                                                    key={
                                                                        column.id
                                                                    }
                                                                    style={{
                                                                        width:
                                                                            column.width,
                                                                    }}
                                                                    className="table-head-col"
                                                                >
                                                                    {
                                                                        column.label
                                                                    }
                                                                </TableCell>
                                                            ),
                                                        )}
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {filteredUsers.length ===
                                                        0 && (
                                                        <TableRow>
                                                            <TableCell
                                                                colSpan={
                                                                    columns.length
                                                                }
                                                                style={{
                                                                    textAlign:
                                                                        'center',
                                                                }}
                                                            >
                                                                No Data Found
                                                            </TableCell>
                                                        </TableRow>
                                                    )}
                                                    {filteredUsers.map(
                                                        (row, index) => {
                                                            return (
                                                                <TableRow
                                                                    hover
                                                                    role="checkbox"
                                                                    tabIndex={
                                                                        -1
                                                                    }
                                                                    key={
                                                                        row.code
                                                                    }
                                                                >
                                                                    {columns.map(
                                                                        (
                                                                            column,
                                                                        ) => {
                                                                            const value =
                                                                                column.id ===
                                                                                'roleIds'
                                                                                    ? row
                                                                                    : row[
                                                                                          column
                                                                                              .id
                                                                                      ];
                                                                            return (
                                                                                <TableCell
                                                                                    key={
                                                                                        column.id
                                                                                    }
                                                                                    align={
                                                                                        column.align
                                                                                    }
                                                                                >
                                                                                    {column.format
                                                                                        ? column.format(
                                                                                              value,
                                                                                          )
                                                                                        : value}
                                                                                    {column.id ===
                                                                                        'actions' && (
                                                                                        <>
                                                                                            <span
                                                                                                className="icon-class icon-settings-icon"
                                                                                                aria-controls={`simple-menu${index}`}
                                                                                                onClick={(
                                                                                                    e,
                                                                                                ) =>
                                                                                                    handleClick(
                                                                                                        e,
                                                                                                        `simple-menu${index}`,
                                                                                                    )
                                                                                                }
                                                                                            ></span>
                                                                                            {anchorEl.target && (
                                                                                                <Menu
                                                                                                    id={`simple-menu${index}`}
                                                                                                    anchorEl={
                                                                                                        anchorEl.target
                                                                                                    }
                                                                                                    open={
                                                                                                        anchorEl.text ===
                                                                                                        `simple-menu${index}`
                                                                                                    }
                                                                                                    onClose={
                                                                                                        handleClose
                                                                                                    }
                                                                                                >
                                                                                                    {row.roleIds &&
                                                                                                        row.roleIds.every(
                                                                                                            (
                                                                                                                val,
                                                                                                            ) =>
                                                                                                                val !==
                                                                                                                null,
                                                                                                        ) && (
                                                                                                            <MenuItem
                                                                                                                key={
                                                                                                                    888
                                                                                                                }
                                                                                                                onClick={() => {
                                                                                                                    handleClose();
                                                                                                                    onChangeRoleUser(
                                                                                                                        row,
                                                                                                                    );
                                                                                                                }}
                                                                                                            >
                                                                                                                Change
                                                                                                                User
                                                                                                                Type
                                                                                                            </MenuItem>
                                                                                                        )}
                                                                                                    {row.roleIds &&
                                                                                                        row.roleIds.every(
                                                                                                            (
                                                                                                                val,
                                                                                                            ) =>
                                                                                                                val !=
                                                                                                                null,
                                                                                                        ) && (
                                                                                                            <MenuItem
                                                                                                                key={
                                                                                                                    889
                                                                                                                }
                                                                                                                className="danger-menu-options"
                                                                                                                onClick={() => {
                                                                                                                    handleClose();
                                                                                                                    onDeleteUser(
                                                                                                                        row,
                                                                                                                    );
                                                                                                                }}
                                                                                                            >
                                                                                                                Remove
                                                                                                                from
                                                                                                                Organization
                                                                                                            </MenuItem>
                                                                                                        )}
                                                                                                    {(!row.roleIds ||
                                                                                                        row.roleIds.every(
                                                                                                            (
                                                                                                                val,
                                                                                                            ) =>
                                                                                                                val ==
                                                                                                                null,
                                                                                                        )) && (
                                                                                                        <MenuItem
                                                                                                            key={
                                                                                                                890
                                                                                                            }
                                                                                                            onClick={() =>
                                                                                                                onResendInvite(
                                                                                                                    row,
                                                                                                                )
                                                                                                            }
                                                                                                        >
                                                                                                            Resend
                                                                                                            Invitation
                                                                                                        </MenuItem>
                                                                                                    )}
                                                                                                    {(!row.roleIds ||
                                                                                                        row.roleIds.every(
                                                                                                            (
                                                                                                                val,
                                                                                                            ) =>
                                                                                                                val ==
                                                                                                                null,
                                                                                                        )) && (
                                                                                                        <MenuItem
                                                                                                            key={
                                                                                                                891
                                                                                                            }
                                                                                                            className="danger-menu-options"
                                                                                                            onClick={() => {
                                                                                                                handleClose();
                                                                                                                onDeleteUser(
                                                                                                                    row,
                                                                                                                );
                                                                                                            }}
                                                                                                        >
                                                                                                            Cancel
                                                                                                            Invitation
                                                                                                        </MenuItem>
                                                                                                    )}
                                                                                                </Menu>
                                                                                            )}
                                                                                        </>
                                                                                    )}
                                                                                </TableCell>
                                                                            );
                                                                        },
                                                                    )}
                                                                </TableRow>
                                                            );
                                                        },
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </div>
                                </div>
                            </>
                        )}
                    </div>
                )}
            </div>
        );
    }

    return <>{getContent()}</>;
}

AdminContentUsers.propTypes = {
    //an array of Users
    users: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.number,
            name: PropTypes.string,
            profilePicture: PropTypes.string,
        }),
    ),

    loading: PropTypes.bool,
    count: PropTypes.number,
    error: PropTypes.string,
};

AdminContentUsers.defaultProps = {
    loading: false,
    count: null,
    users: null,
    error: null,
};

export default AdminContentUsers;
